export default {
taskRecord: {
  title: "รางวัลภารกิจ",
  loading: "กำลังโหลด...",
  empty: "ไม่มีรางวัล",
  completed: "ภารกิจนี้เสร็จแล้ว",
  desc: "ทำภารกิจให้สำเร็จเพื่อรับรางวัล",
  close: "ปิด",
  add: "เพิ่ม",
  addEmail: "เพิ่มอีเมล",
  addPhoneNumber: "เพิ่มหมายเลขโทรศัพท์",
  addBirthday: "เพิ่มวันเกิด",
  downloadNow: "ดาวน์โหลดเลย",
  phone: "หมายเลขโทรศัพท์",
  email: "อีเมล",
  bank: "บัตรธนาคาร",
  birthday: "วันเกิด",
  download: "ดาวน์โหลด",
  downloadApp: "ดาวน์โหลด APP",
  registerBonus: "โบนัสสมัครสมาชิก",
  firstInviteBonus: "โบนัสเชิญเพื่อนคนแรก",
  invite: "เชิญ",
  inviteNow: "เชิญเพื่อน",
  go: "ไป",
  receive: "รับ",
  received: "รับแล้ว",
  task: "ภารกิจ",
  claimRewards: 'รับรางวัล',
  receiveSuccess: 'รับรางวัลสำเร็จ',
  receiveFail: 'รับรางวัลไม่สำเร็จ'
}
};
